export const bankDeposit = {
  depositInstructions: "Instrucciones de depósito",
  depositInstructionsMessageVzla:
    "Registra tu pago móvil para pagos BDV automáticos. Si ya pagaste sin registrar, usa este formulario.",
  depositInstructionsMessagePlaza:
    "Estimado usuario, para validar tu pago móvil y acreditarlo en tu billetera virtual, debe ser realizado con la misma cédula y número de teléfono con los que registraste tu usuario. Si tienes otro número de teléfono asociado a la misma cédula, solo tienes que agregarlo a tus cuentas de pago móvil para que el pago sea acreditado.",
  depositInstructionsImportantMessage: "IMPORTANTE: El saldo se actualizará al hacer clic en continuar",
  depositInstructionsBank: "Banco",
  depositInstructionsMobilePhone: "Teléfono",
  depositInstructionsContinue: "Continuar",
  depositInstructionsBack: "Volver",
  depositInstructionsCancel: "Cancelar",
  depositInstructionsCopy: "Copiar",
  depositInstructionsCopied: "Copiado!",
  depositInstructionsError: "Hubo un error: ",
  depositInstructionsOptions: "Para continuar, por favor elija uno de los métodos de depósito disponibles",
  depositInstructionsBankTitle: "¡Éxito!",
  depositInstructionsBankSuccess: "Depósito consolidado con éxito!",
  depositInstructionsBankWarning: "Atención!",
  depositInstructionsBanckError: "No se encontraron transacciones",

  depositInstructionsBankOptionsTitle: "Para continuar, por favor elija uno de sus bancos preferidos.",
  depositInstructionsBankOptions: "Seleccione un banco",
  depositInstructionsBankVzlaSelectDate: "Seleccione una fecha",

  depositInstructionsCancelBtn: "Cancelar",
  depositInstructionsCopyBtnTitle: "Pulsa el botón para copiar",

  // VENEZUELA BANK
  depositInstructionsBankVzlaReference: "Referencia",
  depositInstructionsBankVzlaAmount: "Monto depositado",
  depositInstructionsBankVzlaDate: "Fecha",
  depositInstructionsBankVzlaBank: "Banco",
  depositInstructionsBankVzlaBankOptions: "Seleccione un banco",
  depositInstructionsBankVzlaForm: "Formulario",
  depositInstructionsBankVzlaFormTitle: "Formulario de registro de pago",
  depositInstructionsBankVzlaFormInfo: "Usa el formulario si ya pagaste",

  //ZELLE
  depositInstructionsZelleMessage:
    "Antes de realizar esta transacción Zelle debes contactar a soporte técnico para verificar la conversión de saldo de USD a bolívares y validar su pago",
  depositInstructionsZelleEmail: "Correo",
  depositInstructionsZelleCopyBtnTitle: "Toca el botón para copiar el correo",
  depositInstructionsSupport: "Contactar soporte",

  //BINANCE
  depositInstructionsBinanceTitle: "Depósito Binance USDT",
  depositInstructionsBinanceAmount: "Monto",
  depositInstructionsBinanceMinAmount: "Depósito mínimo",
  depositInstructionsBinanceCompletePayment: "Completa tu pago en Binance",
  depositInstructionsBinanceOptions: "Elige tu método de pago preferido a continuación",
  depositInstructionsBinanceOptionsTitle: "Métodos de pago",
  depositInstructionsBinanceUseQR: "Escanea este código QR con tu aplicación de Binance",
  depositInstructionsBinanceLink: "Haz clic para abrir la página de pago en Binance",
  depositInstructionsBinanceOpenLink: "Abrir enlace de pago de Binance",
  depositInstructionsBinanceStatus: "Estado de la transacción",
  depositInstructionsBinanceContinue: "Continuar",
  depositInstructionsBinanceBack: "Volver",
  depositInstructionsBinanceCheckingStatus: "Verificando estado...",
  depositInstructionsBinancePending: "pendiente",
  depositInstructionsBinanceEnterAmount: "Ingrese el monto a depositar",
  depositInstructionsBinanceGeneratedLink: "¡Enlace de pago generado! Elige tu método de pago preferido.",
  depositInstructionsBinanceError: "No se pudo crear el depósito. Por favor, inténtalo de nuevo.",
  depositInstructionsBinanceValidAmount: "Por favor, ingresa un monto válido",
  depositInstructionsBinancePaymentCompleted: "¡Pago completado con éxito!",

  //PAYKU
  depositInstructionsPaykuTitle: "Depósito Payku CLP",
  depositInstructionsPaykuDescription: "Realiza depósitos en Pesos Chilenos usando varios métodos de pago",
  depositInstructionsPaykuAmount: "Monto",
  depositInstructionsPaykuEmail: "Correo electrónico",
  depositInstructionsPaykuPaymentMethod: "Método de pago",
  depositInstructionsPaykuMinAmount: "Depósito mínimo: 5.000 CLP",
  depositInstructionsPaykuMinAmountCustom: "Depósito mínimo:",
  depositInstructionsPaykuFailedTransactionMin: "Transacción fallida. El depósito mínimo es:",
  depositInstructionsPaykuEnterAmount: "Ingrese el monto a depositar",
  depositInstructionsPaykuEmailPlaceholder: "tu@correo.com",
  depositInstructionsPaykuSelectMethod: "Seleccionar método de pago",
  depositInstructionsPaykuCreatePayment: "Crear Pago",
  depositInstructionsPaykuCompletePayment: "Completa tu Pago Payku",
  depositInstructionsPaykuOptions: "Completa tu pago en la ventana abierta.",
  depositInstructionsPaykuOpenLink: "Abrir Enlace de Pago",
  depositInstructionsPaykuStatus: "Estado del Pago",
  depositInstructionsPaykuCheckingStatus: "Verificando estado...",
  depositInstructionsPaykuPending: "Pendiente",
  depositInstructionsPaykuapproved: "Aprobado",
  depositInstructionsPaykucompleted: "Completado",
  depositInstructionsPaykurejected: "Rechazado",
  depositInstructionsPaykuexpired: "Expirado",
  depositInstructionsPaykuInstructions: "Serás redirigido de vuelta una vez que se procese el pago.",
  depositInstructionsPaykuError: "No se pudo crear el pago. Por favor, inténtalo de nuevo.",
  depositInstructionsPaykuValidEmail: "Por favor, ingresa una dirección de correo válida",
  depositInstructionsPaykuPaymentCompleted: "¡Pago completado con éxito!",
  depositInstructionsPaykuPaymentRejected: "El pago fue rechazado",
  depositInstructionsPaykuPaymentExpired: "El pago expiró",
  depositInstructionsPaykuUnsupportedCurrency: "Moneda no soportada",
  depositInstructionsPaykuOnlyCLP: "Payku solo está disponible para Pesos Chilenos (CLP)",
  depositInstructionsPaykuAllMethods: "Todos los métodos",
  depositInstructionsPaykuAllMethodsDescription: "Recomendado - Todos los métodos disponibles",
  depositInstructionsPaykuWebpayDescription: "Método de pago más común",
  depositInstructionsPaykuWebpayPlus1_3: "Webpay plus (1-3 cuotas)",
  depositInstructionsPaykuWebpayPlus4_6: "Webpay plus (4-6 cuotas)",
  depositInstructionsPaykuWebpayPlus7_12: "Webpay plus (7-12 cuotas)",
  depositInstructionsPaykuWebpayPlusDesc: "Opción de crédito",

  // PAYKU WITHDRAWAL
  withdrawalPaykuTitle: "Retiro Payku CLP",
  withdrawalPaykuAvailableBalance: "Saldo Disponible",
  withdrawalPaykuAmount: "Monto",
  withdrawalPaykuBeneficiaryName: "Nombre del Beneficiario",
  withdrawalPaykuEmail: "Correo electrónico",
  withdrawalPaykuPhone: "Teléfono",
  withdrawalPaykuRUT: "RUT Chileno",
  withdrawalPaykuBank: "Banco",
  withdrawalPaykuAccountType: "Tipo de Cuenta",
  withdrawalPaykuAccountNumber: "Número de Cuenta",
  withdrawalPaykuMinAmount: "Retiro mínimo: 1.000 CLP",
  withdrawalPaykuEnterAmount: "Ingrese el monto a retirar",
  withdrawalPaykuBeneficiaryNamePlaceholder: "Nombre completo del titular de la cuenta",
  withdrawalPaykuEmailPlaceholder: "tu@correo.com",
  withdrawalPaykuPhonePlaceholder: "+56912345678",
  withdrawalPaykuRUTPlaceholder: "12345678-9",
  withdrawalPaykuRUTFormat: "Formato: 12345678-9",
  withdrawalPaykuSelectBank: "Seleccionar banco",
  withdrawalPaykuAccountNumberPlaceholder: "Número de cuenta",
  withdrawalPaykuSubmit: "Enviar Retiro",
  withdrawalPaykuSuccess: "¡Solicitud de retiro enviada con éxito!",
  withdrawalPaykuError: "No se pudo enviar el retiro. Por favor, inténtalo de nuevo.",
  withdrawalPaykuInsufficientBalance: "Saldo insuficiente",
  withdrawalPaykuBeneficiaryNameRequired: "El nombre del beneficiario es requerido",
  withdrawalPaykuValidEmail: "Por favor, ingresa una dirección de correo válida",
  withdrawalPaykuPhoneRequired: "El número de teléfono es requerido",
  withdrawalPaykuValidRUT: "Por favor, ingresa un RUT chileno válido (formato: 12345678-9)",
  withdrawalPaykuBankRequired: "Por favor, selecciona un banco",
  withdrawalPaykuAccountNumberRequired: "El número de cuenta es requerido",
  withdrawalPaykuUnsupportedCurrency: "Moneda no soportada",
  withdrawalPaykuOnlyCLP: "Los retiros Payku solo están disponibles para Pesos Chilenos (CLP)",

  // PAYKU CALLBACK PAGE
  paykuCallbackVerifying: "Verificando Pago",
  paykuCallbackVerifyingMessage: "Por favor espere mientras verificamos el estado de su transacción...",
  paykuCallbackSuccess: "¡Pago Exitoso!",
  paykuCallbackSuccessMessage: "Tu depósito ha sido procesado correctamente. El saldo se ha acreditado a tu cuenta.",
  paykuCallbackFailed: "Pago Fallido",
  paykuCallbackFailedMessage:
    "Lo sentimos, tu pago no pudo ser procesado. Por favor intenta nuevamente o contacta a soporte.",
  paykuCallbackPending: "Pago Pendiente",
  paykuCallbackPendingMessage: "Tu pago está siendo procesado. Recibirás una notificación cuando se complete.",
  paykuCallbackOrderId: "ID de Orden",
  paykuCallbackAmount: "Monto",
  paykuCallbackRedirectMessage: "Serás redirigido a la página principal en {{seconds}} segundos...",
  paykuCallbackGoHome: "Ir al Inicio",
};
